import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChefBuddeeUI from "./ChefBuddeeUI";
import Landing from "./Landing";
import PurchaseSuccessHandler from "./PurchaseSuccessHandler";
import PurchaseCancelHandler from "./PurchaseCancelHandler";
import { ThemeProvider } from "./components/ThemeContext";
import { ToastProvider } from "./components/Toast";
import AgeGate from "./components/AgeGate";
import InstallPrompt from "./components/InstallPrompt";

export default function App() {
  return (
    <AgeGate>
      <ThemeProvider>
        <ToastProvider>
        <InstallPrompt />
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/app" element={<ChefBuddeeUI />} />
            <Route path="/success" element={<PurchaseSuccessHandler />} />
            <Route path="/cancel" element={<PurchaseCancelHandler />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </Router>
        </ToastProvider>
      </ThemeProvider>
    </AgeGate>
  );
}
